// CourtModeSelector — ActivityWizard Steg 3 (delspår multi-bana). Toggle-only: Vilken som
// helst (auto, default) / Specifik banor. Renderas ENDAST när "Vill du boka bana?" = Ja.
// "Ingen bana" är wantsCourt=false (WantsCourtToggle). Bana-VALET för specifik-läget sker i
// MultiCourtPicker (exakt N banor) — den här komponenten äger bara läges-växeln.
//
// Historik: 3c (3-läge none/auto/specific) → 3d (2-läge, inbyggd single-court-lista) →
// multi-bana (toggle-only; multi-select flyttad till MultiCourtPicker).

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export type ActiveCourtMode = "auto" | "specific";

interface CourtModeSelectorProps {
  mode: ActiveCourtMode;
  onModeChange: (mode: ActiveCourtMode) => void;
}

const MODES: ActiveCourtMode[] = ["auto", "specific"];

export default function CourtModeSelector({ mode, onModeChange }: CourtModeSelectorProps) {
  const { t } = useTranslation("admin");

  const modeLabel = (m: ActiveCourtMode) =>
    m === "auto"
      ? t("activityWizard.step3.courtMode.auto", { defaultValue: "Vilken som helst" })
      : t("activityWizard.step3.courtMode.specific", { defaultValue: "Specifik banor" });

  return (
    <div className="grid grid-cols-2 gap-1 rounded-2xl border border-border/60 bg-muted/50 p-1">
      {MODES.map((m) => (
        <button
          key={m}
          type="button"
          aria-pressed={mode === m}
          data-testid={`court-mode-${m}`}
          onClick={() => onModeChange(m)}
          className={cn(
            "rounded-xl border border-transparent p-2.5 text-sm font-medium transition-colors",
            mode === m
              ? "livfull-pill-selected"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {modeLabel(m)}
        </button>
      ))}
    </div>
  );
}
